import React from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';

function BasicField(props) {
  return (
    <>
      <Typography variant='subtitle1'>
        {props.title}
      </Typography>
      <TextField
        style={ { marginBottom: '8px' } }
        onChange={ (ev) => { return props.onChange(ev.target.value); } }
        value={ props.field }
        variant='outlined'
        size='small'
        disabled={ props.disabled }
        fullWidth
        multiline={ props.multiline }
        error={ props.error }
        helperText={ props.helperText }
      />
    </>
  );
}

export default BasicField;
